// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"5631": "__federation_expose_SharedFolderPage","9949": "__federation_expose_FilesPage",}[chunkId] || chunkId) + "." + {"5631": "0953ef6e358f570a","5913": "5f1f7cec07437f6f","7638": "0f9c13ee34d8afc0","8773": "c16fe6d6755f7960","9949": "931db34178b4827f",}[chunkId] + ".css"
}